export default __webpack_public_path__ + "static/media/picDiepPham.393f548a.png";